import React from "react";
import { useTranslation } from "react-i18next";
import PageHeaderSolutions from "../components/PageHeaderSolutions";
import { CaretRightFilled } from "@ant-design/icons";
// import gene_expression from "../assets/images/applications/market_basket_analysis.jpg";
import HealthcareBanner from "../appareas/HealthcareBanner";

const GeneExpression = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageHeaderSolutions></PageHeaderSolutions>
      <section className="mt-24 w-full h-full relative bg-center bg-cover p-5 border-2 border-blue-900 rounded-lg bg-white">
        <div> <HealthcareBanner></HealthcareBanner> </div>
        <div className="items-center text-center">
          <h3 className="mt-2 text-blue-900 text-4xl font-semibold mb-2">
            {t("gene_expression")}
          </h3>
        </div>

        <p className="text-2xl">
          <CaretRightFilled />
          {t("gene_expression_description1")}
        </p>


        {/* <img src={gene_expression} width={1200} height={1200} alt="gene_expression" /> */}
      </section>
    </>
  );
};

export default GeneExpression;
